/* SocialLinksParser.js */
/* v2 */

const SocialLinksParser = {
  parse: (rde) => {
    const result = { description: rde, links: [], hashtags: [], skin: null };

    // Getting hashtags
    const splitted2 = (rde.includes('||)') ? rde.split('||)') : [rde, ' ']);
    const hashtagsArr = splitted2[1].split(' ');
    if (hashtagsArr) {
      let hashtags = [];
      hashtagsArr.forEach((item) => {
        if (item) { hashtags.push(item.replace('#', '')); }
      });
      result.hashtags = hashtags;
    }

    const splitted = splitted2[0].split(/\n\n/);

    // Getting description
    result.description = splitted[0];

    const links = [];
    let skin = null;
    const lines = rde.split(/\n/);
    if (lines && lines.length > 0) {
      const linkMatch1 = /^[ ]*([-+&@#/%?=~_|$!,.;*\w()]+[-+&@#/%?=~_|$!,.;*\w() ]*)[ ]*:[ ]*(?:(?:https?:\/\/)|www\.)([-A-Z0-9+&@#/%?=~_|$!:,.;]*[A-Z0-9+&@#/%=~_|$])[\r| ]*$/im;
      const linkMatch2 = /[ ](?:(?:https?:\/\/)|www.)([-A-Z0-9+&@#/%?=~_|$!:,.;]*[A-Z0-9+&@#/%=~_|$])/i 
      const linkMatch3 = /\b(?:(?:https?:\/\/)|www\.)([-A-Z0-9+&@#/%?=~_|$!:,.;]*[A-Z0-9+&@#/%=~_|$])/i;

      lines.forEach((line) => {
        let foundLink = false;

        // Searching for link matches
        let matches = line.match(linkMatch1);
        if (matches && matches[1] && matches[2]) {
          links.push({label: matches[1], url: `https://${matches[2]}`});
          foundLink = true;
        }
        if (!foundLink) {
          matches = line.match(linkMatch2);
          if (matches && matches[1] && matches[2]) {
            links.push({label: matches[1], url: `https://${matches[2]}`});
            foundLink = true;
          }
        }
        if (!foundLink) {
          matches = line.match(linkMatch3);
          if (matches && matches[1] && matches[2]) {
            links.push({label: matches[1], url: `https://${matches[2]}`});
            foundLink = true;
          }
        }

        // Searching for skin
        if (!foundLink && skin === null) {
          // console.log(line);
          if (line.includes('((+))')) {
            const skinMatch = line.replace(/\D/g, '');
            if (skinMatch) { skin = skinMatch; }
          }
        }
        
      });
    }
    result.links = links;

    if (skin === null) { skin = 1; }
    result.skin = parseInt(skin);

    return result;
  }
}

export default SocialLinksParser;
